module.exports = __webpack_public_path__ + "assets/lock-white.cbf3d8ef.svg";